<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold mb-base">Service Fee</h4>
                    <!-- <div class="flex align-center">
                        <vs-switch v-model="service_fee_active" class="my-6" @click.stop="updateServiceFee('switch')" />
                        <span class="pl-5">A discount amount shall be applied for orders paid in cash</span>
                    </div> -->
                    <div>
                        <ul class="centerx flex align-center w-8/12 mb-base">
                            <li class="mr-6">Service Fee (%): </li>
                            <!-- <vs-input min="0" :max="max" v-model="service_fee_value" :disabled="!service_fee_active" class="w-1/2" :key="input_number_key" v-on:keypress="isNumber($event)"></vs-input> -->
                            <vs-input min="0" :max="max" v-model="service_fee_value" class="w-1/2" :key="input_number_key" v-on:keypress="isNumber($event)" disabled></vs-input>
                        </ul>

                        <!-- <div class="flex-center mt-base pt-5">
                            <vs-button style="min-width: 150px;" @click="updateServiceFee()">Save</vs-button>
                        </div> -->
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: 'service-fee-setting',
    data() {
        return {
            service_fee_active: true,
            service_fee_value: 0,
            max: 100,
            input_number_key: 0,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: '',
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        },
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: this.action_type + ' Service Fee Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            // if ((charCode > 31 && (charCode < 48 || charCode > 57)) || parseInt(this.service_fee_value + '' + evt.key) > this.max) {
            if ((charCode > 31 &&  (charCode < 48 || charCode > 57) && charCode !== 46) 
                || (charCode == 46 && this.service_fee_value.indexOf(".") != -1) 
                || parseFloat(this.service_fee_value + '' + evt.key) > this.max) {
                evt.preventDefault();
            } else {
                // if(this.service_fee_value == 0) {
                //     this.service_fee_value = '';
                // }
                if (charCode == 46) {
                    if(this.service_fee_value == "") {
                        this.service_fee_value = 0;
                    }
                } else if (this.service_fee_value === 0 || this.service_fee_value === '0') {
                    this.service_fee_value = "";
                }
                return true;
            }
        },
        updateServiceFee() {
            let obj = {
                fee: +(Math.round(this.service_fee_value + "e+5") + "e-5"),
                // state: this.service_fee_active ? 1 : 0
                state: 1
            }

            // if(type == 'switch') {
            //     obj = {
            //         fee: this.$store.getters["appSetting/serviceFee"].fee,
            //         state: !this.service_fee_active ? 1 : 0
            //     }
            // }

            this.action_type = "Update";
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch("appSetting/UPDATE_SERVICE_FEE", obj).then(() => {
                this.closeLoading();
                this.service_fee_value = obj.fee;
                this.input_number_key++;
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Service Fee Success',
                    color:'success',
                    position:'top-right'})
            }).catch((err) => {
                this.closeLoading();
                console.log('Error: ', err);
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Service Fee Failed',
                    color:'danger',
                    position:'top-right'})
            })
        },
        // updateCashDiscountMode(type) {
        //     const obj = {
        //         key: 'config.pos.cash_discount_active',
        //         value: JSON.stringify({
        //             status: type == 'switch' ? (!this.cash_discount_active ? 1 : 0) : (this.cash_discount_active ? 1 : 0),
        //             value: (this.discount_value == '' || this.discount_value == null || this.discount_value == undefined) ? 0 : 
        //                 (this.discount_type == 'percent' ? parseFloat(this.discount_value)/100 : parseFloat(this.discount_value)),
        //             type: this.discount_type
        //         })
        //     }
        //     // console.log(obj);
        //     this.action_type = 'Update';
        //     this.openLoadingInDiv();
        //     this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
        //         this.closeLoading();
        //         this.$vs.notify({
        //             title:'Notification',
        //             text:'Update Cash Discount Mode Success',
        //             color:'success',
        //             position:'top-right'})
        //     })
        // }
    },
    created() {
        this.$store.dispatch("appSetting/GET_SERVICE_FEE").then(() => {
            this.loaded_data_num++;
            let data = this.$store.getters["appSetting/serviceFee"];
            if(data && data.fee != null && data.fee != undefined) {
                this.service_fee_value = data.fee;
                this.service_fee_active = data.state == 1 ? true : false;
            }
        }).catch((err) => {
            console.log('Error: ', err);
        })
        // const obj = {
        //     key: 'config.pos.cash_discount_active'
        // }

        // this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
        //     this.loaded_data_num++;
        //     let data = this.$store.getters["appSetting/keyStorage"];
        //     let cash_discount_active = JSON.parse(data.value);
        //     if(cash_discount_active) {
        //         this.cash_discount_active = cash_discount_active.status == 1 ? true : false;
        //         this.discount_type = cash_discount_active.type;
        //         this.discount_value = cash_discount_active.value;
        //         if(this.discount_type == 'value') {
        //             this.max = 99999999999;
        //         } else {
        //             this.discount_value = this.discount_value * 100;
        //         }
        //     }
        // }).catch(() => {
        //     const obj = {
        //         key: 'config.pos.cash_discount_active',
        //         value: JSON.stringify({
        //             status: 0,
        //             value: 0,
        //             type: 'percent'
        //         })
        //     }
        //     this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
        //         this.loaded_data_num++;
        //     })
        // })
    }
}
</script>